var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatsmile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1C3.33333 1 1 3.33333 1 8C1 12.6667 3.33333 15 8 15C12.6667 15 15 12.6667 15 8C15 3.33333 12.6667 1 8 1Z",
    stroke: "#848E9D",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6554 5.77055C10.6554 5.94802 10.5115 6.09189 10.334 6.09189C10.1566 6.09189 10.0127 5.94802 10.0127 5.77055C10.0127 5.59308 10.1566 5.44922 10.334 5.44922C10.5115 5.44922 10.6554 5.59308 10.6554 5.77055Z",
    fill: "#848E9D",
    stroke: "#848E9D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66704 6.59189C6.12065 6.59189 6.48837 6.22416 6.48837 5.77055C6.48837 5.31694 6.12065 4.94922 5.66704 4.94922C5.21343 4.94922 4.8457 5.31694 4.8457 5.77055C4.8457 6.22416 5.21343 6.59189 5.66704 6.59189Z",
    fill: "#848E9D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6123 9.58594C5.4243 10.5473 6.64697 11.1539 8.0003 11.1539C9.35364 11.1539 10.5763 10.5473 11.3883 9.58594",
    stroke: "#848E9D",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatsmile);
export default __webpack_public_path__ + "static/media/chatsmile.4185382a9690a01ed3ab44f4828012fb.svg";
export { ForwardRef as ReactComponent };